export const CREATE_USER_EXTENSION = 'CREATE_USER_EXTENSION'
export const CREATE_USER_EXTENSION_DONE = 'CREATE_USER_EXTENSION_DONE'
